module.exports = __webpack_public_path__ + "static/img/certificate.c9c535f0.png";